import type { ExtractPropTypes, PropType, ExtractPublicPropTypes } from 'vue'
import {
  formProps as elFormProps,
  formEmits as elFormEmits,
} from 'element-plus'
import type { FormItemProps } from './form-item'
const expandFormProps = {
  // 表单列表
  formItemList: {
    type: Array as PropType<FormItemProps[]>,
    default: () => [] as FormItemProps[],
  },
  // 是否显示折叠
  isShowFold: Boolean,

  // 最大显示的表单数
  showFieldCount: {
    type: Number,
    default: 8,
  },
  // 每行的列数
  col: {
    type: Number,
    default: 4,
  },
}
export const formProps = {
  ...elFormProps,
  ...expandFormProps,
  size: {
    ...elFormProps.size,
    default: 'small',
  },
  // 标签的长度
  labelWidth: {
    ...elFormProps.labelWidth,
    default: 100,
  },
  scrollIntoViewOptions: {
    ...elFormProps.scrollIntoViewOptions,
    default: () => {
      return { inline: 'center' }
    },
  },
} as const
export type FormProps = ExtractPublicPropTypes<typeof formProps>
export const expandFormPropsKeys = Object.keys(expandFormProps)
/* eslint-disable @typescript-eslint/no-unused-vars */
export const formEmits = {
  ...elFormEmits,
  toggleStatus: (status: boolean) => true, // 折叠状态切换时触发
}
/* eslint-enable @typescript-eslint/no-unused-vars */

export type FormEmits = typeof formEmits
export const formEmitsKeys = Object.keys(formEmits)
